import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { requestCreateReturnFromTicket } from "./createReturnFromTicket.request";
import { CreateReturnFromTicketBody } from "./createReturnFromTicket.types";

const useCreateReturnFromTicket = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    CreateReturnFromTicketBody
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestCreateReturnFromTicket,
    onError: toastServerError,
    ...options,
    onSuccess: (data, vars, ctx) => {
      // The ticket moves Open -> Processing on the server, and the order now
      // shows up in Returns — both lists are stale.
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY, "list"],
      });
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY, "return-context", vars.ticketId],
      });
      options?.onSuccess?.(data, vars, ctx);
    },
  });
};

export default useCreateReturnFromTicket;
